import { render, staticRenderFns } from "./change-avatar-dialog.vue?vue&type=template&id=266ae158&scoped=true&"
import script from "./change-avatar-dialog.vue?vue&type=script&lang=js&"
export * from "./change-avatar-dialog.vue?vue&type=script&lang=js&"
import style0 from "./change-avatar-dialog.vue?vue&type=style&index=0&id=266ae158&prod&lang=less&scoped=true&"
import style1 from "./change-avatar-dialog.vue?vue&type=style&index=1&id=266ae158&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266ae158",
  null
  
)

export default component.exports